export default "__VITE_ASSET__CAOdVn4F__"